const { lessGlobalVars } = require("./LessGlobalVars");

const Aocubo = require("./AoCuboBrand");
const CasasEnElEste = require("./CasasEnElEsteBrand");
const InfoCasas = require("./InfoCasasBrand");

const { getBranding } = require("./getBranding");

module.exports = {
	AoCuboBrand: Aocubo,
	CasasEnElEsteBrand: CasasEnElEste,
	InfoCasasBrand: InfoCasas,
	lessGlobalVars: lessGlobalVars,
	getBranding: getBranding,
};
